import _ from 'lodash';

export default {
    namespace: true,

    state: {
        companyAnalytics: {},
    },

    mutations: {
        SET_COMPANY_ANALYTICS(state, analytics) {
            state.companyAnalytics = analytics;
        }
    },

    actions: {
        setCompanyAnalytics(vuexContext, analytics) {
            vuexContext.commit('SET_COMPANY_ANALYTICS', analytics);
        },
    },

    getters: {
        companyAnalytics(state) {
            if (!_.isEmpty(state.companyAnalytics)) {
                return state.companyAnalytics.analytics;
            }
            return [];
        },
        companyDefaultAnalytics(state) {
            if (!_.isEmpty(state.companyAnalytics)) {
                return state.companyAnalytics.defaultAnalytics;
            }
            return [];
        },
    }
}
